import BaseLayout from "../../layouts/BaseLayout/index.js";
import PatientListWithFilter from "./PagePatientsList/PatientListWithFilter";
import { useSearchParams } from "react-router-dom";

function PagePatients() {
  const [params] = useSearchParams();
  const category = params.get("cat");

  return (
    <BaseLayout>
      <PatientListWithFilter category={category} />
    </BaseLayout>
  );
}

export default PagePatients;
